<template>
        <div>
            <p-card>
                <p-search-table
                    api-destination="customers"
                    sort-by="transactionDate"
                    :filters="filters"
                    :fields="fields"
                    :showTopPaging="false"
                    :perPage="100"
                    :include-search-input="false"
                    :show-per-page-selector="false"
                    search-destination="rentalHistory"
                    :enable-row-selection="false"
                    edit-key="rentalHistoryId"
                    ref="customerRentalHistory">
                    <template v-slot:cell(edit)="{ value, item }">
                        <p-button
                            variant="outline-primary"
                            class="me-2"
                            @click="openEditRentalModal(item)">
                            Edit
                        </p-button>
                        
                        <p-modal
                            ref="editRentalModal"
                            size="md"
                            :label="'Edit Rental Information'"
                            @ok="saveRentalInfo"
                            @cancel="closeEditRentalModal"
                            ok-label="Save">
                            <template v-slot:default>
                                <div v-if="currentRental">
                                    <p>Rental Term: {{ currentRental.rentalTerm }}</p>
                                    <p>Transaction Number: {{ currentRental.transactionNumber }}</p>
                                    <p>Title: {{ currentRental.title }}</p>
                                    <p>ISBN: {{ currentRental.isbn }}</p>
                                    <p>Rental Status: {{ currentRental.rentalStatus }}</p>

                                    <p-select
                                        label="Change Rental Status"
                                        :options="rentalStatusOptions"
                                        v-model="currentRental.returnStatusId"
                                        :disabled="currentRental.rentalStatusCode !== 'RNR'"
                                        info-message="Rental Status can only be changed for Rental Not Returned."
                                        add-empty-option
                                    />
                                    <div v-if="returnStatusChangeWarning" class="text-warning mt-2">
                                        {{ returnStatusChangeWarning }}
                                    </div>
                                    <div class="form-group">
                                        <p-input
                                            label="Rental Xref"
                                            class="form-control"
                                            type="text"
                                            v-model="currentRental.rentalXref" />
                                    </div>    
                                </div>
                            </template>
                        </p-modal>
                    </template>                
                </p-search-table>
            </p-card>
        </div>
</template>

<script>
import { dateFormatterYear} from '../../components/Common/Formatters.js';
import axios from 'axios';

export default {
    props: {
        customer: [Object]
    },
    data() {
        return {
            currentRental: null,
            rentalStatusOptions: [
                { value: 3, text: 'Billed' },
                { value: 4, text: 'Closed' }
            ],
            filters: {
                perPage: 100,
                customerId: 0
            },
            fields: [
                {
                    key: 'edit',
                    label: '',
                    class: 'tcw100'
                },                
                {
                    label: 'Rental Term',
                    key: 'rentalTerm',
                    sortable: true
                },
                {
                    label: 'Transaction #',
                    key: 'transactionNumber'
                },
                {
                    label: 'Transaction Date',
                    key: 'transactionDate',
                    sortable: true,
                    formatter: dateFormatterYear
                },
                {
                    label: 'Author',
                    key: 'author',
                    sortable: true
                },
                {
                    label: 'Title',
                    key: 'title'
                },
                {
                    label: 'ISBN',
                    key: 'isbn',
                    tdClass: 'noWrap'
                },
                {
                    label: 'Rental Xref',
                    key: 'rentalXref',
                    tdClass: 'noWrap'
                },
                {
                    label: 'Status',
                    key: 'rentalStatus'
                },
                {
                    label: 'Status Date',
                    key: 'statusDate',
                    formatter: dateFormatterYear
                }
            ]
        };
    },
    methods: {
        openEditRentalModal(item) {
            this.currentRental = { ...item };
            this.$refs.editRentalModal.show();
        },
        closeEditRentalModal() {
            this.$refs.editRentalModal.hide();
        },
        saveRentalInfo(event) {
            event.preventDefault(); // Don't automatically close the modal in case the Rental Xref entered is a dupe

            const rentalHistoryInfo = {
                rentalHistoryId: this.currentRental.rentalHistoryId,
                returnStatusId: Number(this.currentRental.returnStatusId),
                rentalXref: this.currentRental.rentalXref
            };

            axios.get('/customers/checkduplicaterentalxref', {
                params: {
                    rentalHistoryId: rentalHistoryInfo.rentalHistoryId,
                    rentalXref: rentalHistoryInfo.rentalXref
                }
            })
            .then(response => {
                if (response.data === true) {
                    this.$appError(`Duplicate Rental Xref ${rentalHistoryInfo.rentalXref} found.`);
                    return;
                }

                return axios.post('/customers/updaterentalinfo', rentalHistoryInfo)
                    .then(() => {
                        this.closeEditRentalModal();
                        this.$refs.customerRentalHistory.refreshSearchResults();
                    });
            })
            .catch(() => {});
        }
    },    
    created: function() {
        this.filters.customerId = this.customer.customerId;
    },
    computed: {
        returnStatusChangeWarning() {
            return !this.currentRental.returnStatusId ? '' : 'This edit may require stock adjustments to ensure that SKU stock on hand and stock ledger are accurate. Please edit stock on hand as needed.';
        }
    }
};
</script>
